import {
  ErrorPopupBackground, ErrorPopupContainer, ErrorPopupCloseIcon, ErrorPopupTextContainer, ErrorPopupHeader,
  ErrorPopupImg, ErrorPopupErrorText, ErrorPopupButtonContainer, ErrorPopupButtonText
} from "views/PaymentFlow/ErrorPopup/ErrorPopup.styles";
import Images from "config/Images";
import {useAppSelector} from "store/hooks";
import {useDispatch} from "react-redux";
import {updateShowErrorPopup} from "store/ui/errorPopupScreen/errorPopupScreen.slice";

function ErrorPopup() {
  const dispatch = useDispatch();
  const plan = useAppSelector(state => state.subscriptionPlan);
  const errorMessage = useAppSelector(state => state.error.errorMessage);

  const buttonStyles = {
    display: 'flex',
    marginTop: '10px',
    width: '30%',
    justifyContent: 'center'
  }

  return (
    <>
      <ErrorPopupBackground onClick={() => dispatch(updateShowErrorPopup(false))}/>

      <ErrorPopupContainer>
        <ErrorPopupCloseIcon className={'fa-solid fa-xmark'} onClick={() => dispatch(updateShowErrorPopup(false))}/>
        <ErrorPopupTextContainer>
          <ErrorPopupHeader> Oops! There was an error. </ErrorPopupHeader>
          <ErrorPopupImg src={Images.paymentsErrorPopup}/>
          <ErrorPopupErrorText>Error: {errorMessage}</ErrorPopupErrorText>
          <ErrorPopupButtonContainer onClick={() => dispatch(updateShowErrorPopup(false))}>
            <ErrorPopupButtonText> Check Payment Method </ErrorPopupButtonText>
          </ErrorPopupButtonContainer>
        </ErrorPopupTextContainer>
      </ErrorPopupContainer>
    </>
  )
}

export default ErrorPopup;
